import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { request } from '@tencent/vft-common/request';
import logger from "./logger";
var cachedConfigs;

function fetchConfigs() {
  return _fetchConfigs.apply(this, arguments);
}

function _fetchConfigs() {
  _fetchConfigs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _window, _window$_dataPreload, _result;

    var result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!cachedConfigs) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", cachedConfigs);

          case 2:
            // 魔方页面进行了预请求并挂载在window._dataPreload.LoginPanel上
            // eslint-disable-next-line
            result = (_window = window) === null || _window === void 0 ? void 0 : (_window$_dataPreload = _window._dataPreload) === null || _window$_dataPreload === void 0 ? void 0 : _window$_dataPreload.LoginPanel;

            if (result) {
              _context.next = 13;
              break;
            }

            _context.prev = 4;
            _context.next = 7;
            return request('https://v.qq.com/cache/wuji/object/?appid=vip&schemaid=login-white-list&schemakey=bfe09fad42e44099953f2739ebab8cb9&link=1', {
              link_query: 'include=rule'
            });

          case 7:
            result = _context.sent;
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            logger.info('请求线上配置异常', _context.t0);

          case 13:
            cachedConfigs = (_result = result) === null || _result === void 0 ? void 0 : _result.data;
            return _context.abrupt("return", cachedConfigs || []);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));
  return _fetchConfigs.apply(this, arguments);
}

function fetch() {
  return _fetch.apply(this, arguments);
}

function _fetch() {
  _fetch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var _navigator, userAgent, configs, _iterator, _step, config, ua, enableWechatLogin, enableQQLogin, enableOpenApp, _iterator2, _step2, uaConfig, rule, pattern;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _navigator = navigator, userAgent = _navigator.userAgent;
            _context2.next = 3;
            return fetchConfigs();

          case 3:
            configs = _context2.sent;
            _iterator = _createForOfIteratorHelper(configs);
            _context2.prev = 5;

            _iterator.s();

          case 7:
            if ((_step = _iterator.n()).done) {
              _context2.next = 31;
              break;
            }

            config = _step.value;
            ua = config.ua, enableWechatLogin = config.enableWechatLogin, enableQQLogin = config.enableQQLogin, enableOpenApp = config.enableOpenApp;
            _iterator2 = _createForOfIteratorHelper(ua);
            _context2.prev = 11;

            _iterator2.s();

          case 13:
            if ((_step2 = _iterator2.n()).done) {
              _context2.next = 21;
              break;
            }

            uaConfig = _step2.value;
            rule = uaConfig.rule;
            pattern = new RegExp(rule, 'i');

            if (!pattern.test(userAgent)) {
              _context2.next = 19;
              break;
            }

            return _context2.abrupt("return", {
              enableWechatLogin: enableWechatLogin,
              enableQQLogin: enableQQLogin,
              enableOpenApp: enableOpenApp
            });

          case 19:
            _context2.next = 13;
            break;

          case 21:
            _context2.next = 26;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](11);

            _iterator2.e(_context2.t0);

          case 26:
            _context2.prev = 26;

            _iterator2.f();

            return _context2.finish(26);

          case 29:
            _context2.next = 7;
            break;

          case 31:
            _context2.next = 36;
            break;

          case 33:
            _context2.prev = 33;
            _context2.t1 = _context2["catch"](5);

            _iterator.e(_context2.t1);

          case 36:
            _context2.prev = 36;

            _iterator.f();

            return _context2.finish(36);

          case 39:
            return _context2.abrupt("return", false);

          case 40:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[5, 33, 36, 39], [11, 23, 26, 29]]);
  }));
  return _fetch.apply(this, arguments);
}

export default {
  fetch: fetch
};